import axios from 'axios'
import inspectionsModule from './inspections/inspectionsModule.js'
import notesModule from './notes/notesModule.js'
import branchesModule from './branches/branchesModule.js'
import certificatesModule from './certificates/certificatesModule.js'
import executoryModule from './executory/executoryModule.js'
import shortResumeModule from './shortResume/shortResumeModule.js'
import tendersModule from './tenders/tendersModule.js'
import blockInvoicesModule from './blockInvoices/blockInvoicesModule.js'
import businessIndexModule from './businessIndex/businessIndexModule.js'
import zalogLeasingModule from './zalogLeasing/zalogLeasingModule.js'

const cardStore = {
    namespaced: true,
    state: () => ({
        // @ts-ignore
        company: window.company,
        certificates: {
            tile: null,
            modal: {
                open: false,
                data: null,
                type: null,
                status: null,
                total_amount: []
            },
        },
        unfairSupplier: null
    }),
    getters: {},
    mutations: {},
    actions: {
        getHTMLForPrint({state, dispatch}: any, printObj: any) {
            try {
                if (!printObj.html) throw new Error("HTML для распечатки не указан")
                let title = printObj.title ? printObj.title : "ЛИК:Эксперт";
                let pdf = printObj.pdf ? "_pdf" : '';
                let style_folder = printObj.style_folder ? printObj.style_folder : printObj.style_name;
                return `<!DOCTYPE html>
                <html>
                    <head>
                        <title>${title}</title>
                        <link rel="stylesheet" type="text/css" href="${document.location.origin}/css/print.css?ver=1" />
                        <link rel="stylesheet" type="text/css" href="${document.location.origin}/components/${style_folder}/${printObj.style_name}${pdf}_print.css?ver=6" />
                    </head>
                    <body>
                        <div id="print-wrapper">
                            <h2 id="print-main-title">${title} | ${state.company.title}</h2>
                            <div id="print-content">${printObj.html}</div>
                        </div>
                  </body>
                </html>`;
            } catch(e) {
                dispatch("showErrorPopUp", "Ошибка распечатки: "+e, { root: true })
            }
        },
        printTile({dispatch}: any, printObj: any) {
            printObj.pdf = false
            return dispatch("getHTMLForPrint", printObj).then((htmlForPrint)=>{
                let printWin = window.open();
                printWin.document.write(htmlForPrint);
                printWin.document.close();
            }).catch(e => dispatch("showErrorPopUp", "Ошибка распечатки: "+e, { root: true }))
        },
        toggleGridUpdate(_, timeout) {
            $("#tiles").trigger("resize");
            // @ts-ignore
            setTimeout(() => UIkit.$html.trigger('changed.uk.dom'), timeout)
        },
        API_PRO({ rootState, dispatch }, { method, url }) {
            return axios({
                method,
                //@ts-ignore
                url: window.api_pro + url,
                headers: rootState.axios.headers
            }).then(result => {
                if (result.data.status.code != 200) {
                    throw result.data.status
                } else {
                    dispatch("toggleGridUpdate", 200)
                    return(result.data.data);
                }
            })
        },
        getUnfairSupplier({ commit, state }) {
            return axios({
                baseURL: `${process.env.API}?unfair_supplier`,
                method: 'post',
                headers: { 'Content-type': 'application/json' },
                data: {
                    auth: {
                        sid: window.apiSession,
                        // @ts-ignore
                        cid: window.cid
                    },
                    method: 'unfair_supplier',
                    data: {
                        action: 'list',
                        ogrn: state.company.ogrn
                    }
                }
            }).then(result => commit('setStateObject', { name: 'card.unfairSupplier', value: result?.data?.data }, { root: true }))
        }
    },
    modules: {
        inspections: inspectionsModule,
        notes: notesModule,
        certificates: certificatesModule,
        branches: branchesModule,
        executory: executoryModule,
        shortResume: shortResumeModule,
        tenders: tendersModule,
        invoices: blockInvoicesModule,
        businessIndex: businessIndexModule,
        zalogLeasing: zalogLeasingModule
    }
}

export default cardStore